import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const updateBillingInformation = createAsyncThunk(
  'billing/updateBillingInformation',
  async (billingInformation, { rejectWithValue }) => {
    const [success, response] = await httpRequest({
      url: '/api/billing/subscription/billing_information',
      method: 'PUT',
      data: { billing_information: billingInformation }
    })

    if (!success) {
      const {
        message: generalErrorMessage,
        payload: {
          message: fieldErrorMessage,
          field
        }
      } = response

      return rejectWithValue({
        message: fieldErrorMessage || generalErrorMessage,
        field
      })
    }

    return response
  }
)
